














import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import SitesSelector from "@/components/SitesSelector.vue";
import DatePicker from "@/components/DatePicker.vue";
import moment from "moment";
import { LayoutModule } from "@/store/layout";
@Component({ components: { SitesSelector, DatePicker } })
export default class ExportExcel extends Vue {
  model = {
    siteId: "",
    date: moment().format(),
  };

  @Watch("model", { deep: true })
  setDialogModel(): void {
    LayoutModule.setDialogModel(this.model);
  }
}
